
import { CampaignFormData } from '../types';

export const getDemoData = (): CampaignFormData => ({
  "core_issue_details": {
    "campaign_name": "NSWNMA 15%",
    "campaign_type": "Industrial Outcome",
    "political_issue": "pay rise for nurses and midwifes, and safe staffing levels in nsw public hospitals",
    "issue_description": "NSW nurses are significantly underpaid compared to state counterparts, and to comparable male dominated areas of the NSW public sector.  the health system has been under continual strain since covid, and the previous government made it worse by effectively freezing wages.  there is a gender pay issue, a state relativity issues and a large over work issue.  the state government committed to extra staffing, but can't deliver, because of the low wages and high workloads.  they say the will fix it, but not all at once, but have not made any realistic offer to move real wages.  instead, they have sent the dispute off to the state Industrial Relations Commission, which will be restrained by state government wages policy as a \"capacity to pay\" barrier",
    "target_entity": "NSW state government",
    "campaign_timeline": "3 months",
    "current_status": "Stalled",
    "start_date": "2024-08-01"
  },
  "documents_and_links": {
    "news_links": [
      "https://thelamp.com.au/professional-issues/public-health/nurses-and-midwives-pay-dispute-debated-in-nsw-parliament/",
      "https://www.greenleft.org.au/content/poll-shows-nsw-voters-back-nurses-midwives-pay-conditions-dispute",
      "https://www.theguardian.com/australia-news/2024/nov/13/nsw-nurses-strike-pay-salary-minns-government-police-wage-increase",
      "https://www.abc.net.au/news/2024-11-12/nsw-nurse-midwives-union-government-refusal-pay-police/104591890"
    ],
    "reference_links": [],
    "uploaded_documents": []
  },
  "stakeholders": {
    "government_officials": [
      "Daniel Mookhey, Treasurer",
      "Chris Minns, Premier",
      "Ryan Park, health minister"
    ],
    "politicians": [
      "John Graham",
      "Penny Sharpe",
      "alp caucus members"
    ],
    "bureaucrats": [],
    "political_allies": [
      "unionsnsw",
      "rtbu"
    ],
    "opposition_groups": [
      "Treasury",
      "hospital LHD boards"
    ],
    "voters_constituents": [
      "union members",
      "healthcare workers",
      "labor leaning voters",
      "voters concerned about healthcare",
      "voters who value universal healthcare"
    ],
    "media_outlets": [
      "ABC news",
      "2 gb radio"
    ],
    "advocacy_groups": [],
    "political_parties": [],
    "union_leadership": [],
    "community_context": "there is broad support for the nurses, but it is not currently active support.  The government has a budget issue, and health is a large part of the budget, so does not want to have to find the money to pay nurses properly.  there is a growing view that health is in crisis, that the government cant manage it, and that they are alienating health workers. Chris Minns is also vulnerable on allegations of sexism, or at least indifference to women, and a refusal to accept gender as a legitimate frame.  the polling has turned, and the government is now behind in the polls. the back bench is nervous, and want to support the nurses, but Minns rules with a very strong \"fear and favour\" approach to controlling his back bench"
  },
  "political_and_strategic": {
    "government_motivations": "The government want to be seen as economic rationalists, keeping the budget under control, and tough on unions",
    "opposition_tactics": "the counter strategy has been to bully back benchers and cross benchers into submission.  the union leadership is portrayed as unrealistic and uncompromising- they asked for staff ratios before the election, and the government delivered, then the union changed the goal posts to wages.  that the union won't accept anything other than a total fix to wage gap overnight, and you can't undo 10 years of neglect in one day.",
    "political_vulnerabilities": "nurses are trusted messengers, and worked hard to help get the government elected. they are vulnerable in a number of seats, and the nurses union being angry with them is politically impactful.  they are just half way through their electoral term, so the relatively comfortable that they have time before any political threat is too damaging, but the back bench is getting nervous.",
    "coalition_opportunities": "there is opportunities to build alliances with other unions, community organisations and some ALP government back benchers "
  },
  "campaign_outcome": {
    "winning_aspiration": "at least a 15% pay rise now",
    "success_metrics": "success will be measured in getting a majority of Caucus to explicitly support more money into health to fund an above  wages policy pay increase.",
    "target_audience": "union members, swing voters or soft ALP voters, government back benchers and caucus members"
  }
});
